<div class="flex flex-col h-full">
  <!--
  Use ngClass instead of ngSwitch to hide the list component.
  This prevents the component from being destroyed and
  loosing it's scroll position when other components are shown.
  -->
  <sd-scan-3d-list
    [quotaExceeded]="quotaExceeded()"
    (exitStationClick)="onExitStationClick()"
    (settingsClick)="onSettingsClick()"
    (modelDetailClick)="onModelDetailClick($event)"
    (clipAndSaveClick)="onClipAndSaveClick($event)"
    class="flex flex-col h-full"
    [ngClass]="{ hidden: listHidden() }"
  ></sd-scan-3d-list>

  @switch (currentView()) {
    @case (scan3dView.Details) {
      @let scan = currentScan();
      @let style = scan3dStyle();

      @if (scan && style) {
        <sd-scan-3d-detail
          [currentModel]="scan"
          [elevationPicking]="elevationPicking()"
          [scan3dStyle]="style"
          [scan3dStyleUom]="scan3dStyleUom()"
          (exitDetailClick)="onExitDetailClick()"
          (styleChange)="onStyleChange($event)"
          (elevationPickingChange)="onElevationPickingChange($event)"
          class="flex flex-col h-full"
        ></sd-scan-3d-detail>
      } @else {
        <div>No model error</div>
      }
    }
    @case (scan3dView.Settings) {
      <sd-scan-3d-settings
        [elevationPicking]="elevationPicking()"
        [scan3dStyleUom]="scan3dStyleUom()"
        (exitSettingsClick)="onExitSettingsClick()"
        (elevationPickingChange)="onElevationPickingChange($event)"
        class="flex flex-col h-full"
      ></sd-scan-3d-settings>
    }
    @case (scan3dView.ClipAndSave) {
      @let clipAndSave = clipAndSaveInput();
      @if (clipAndSave) {
        <sd-clip-and-save
          [pointcloudIds]="clipAndSave.pointcloudIds"
          [clipBox]="clipAndSave.clipBox"
          (exitClipAndSaveClick)="onExitClipAndSaveClick()"
          (saved)="onClipSaved()"
          class="flex flex-col h-full"
        ></sd-clip-and-save>
      }
    }
  }
</div>
